"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataLakeHydrationEventType = exports.isAthenaResultSchemaType = exports.isAthenaQueryParams = exports.isAthenaTables = exports.isAthenaTable = void 0;
const schema = __importStar(require("../schema"));
const DataLakeTypes = __importStar(require("../types/DataLake"));
const DataLake_1 = require("../types/DataLake");
const Log_1 = require("../types/Log");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isAthenaTable = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.AthenaTableSchema,
    typeguardName: 'isAthenaTable',
});
const isAthenaTables = (obj) => {
    return Array.isArray(obj) && obj.every((el) => (0, exports.isAthenaTable)(el));
};
exports.isAthenaTables = isAthenaTables;
exports.isAthenaQueryParams = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.AthenaQueryParamsSchema,
    typeguardName: 'isAthenaQueryParams',
});
const isAthenaResultSchemaType = (obj, logOptions) => {
    let errorMessage = '';
    if (typeof obj !== 'string') {
        errorMessage = `Typeguard: detected non-string type as input, received [type:${typeof obj}]`;
    }
    else {
        const isAcceptedType = DataLake_1.AthenaQueryResultTypeIterable.some((field) => obj === field);
        if (!isAcceptedType) {
            errorMessage = `Typeguard: detected unsupported type:${typeof obj}] Athena Result Schema Type as input`;
        }
    }
    if (errorMessage) {
        if (logOptions?.logger) {
            const errObj = { message: errorMessage };
            logOptions.logger(errObj, logOptions.logLevel || Log_1.LogLevel.Error);
        }
        return false;
    }
    return true;
};
exports.isAthenaResultSchemaType = isAthenaResultSchemaType;
exports.isDataLakeHydrationEventType = (0, typeguardUtils_1.zodTypeGuard)(DataLakeTypes.DataLakeHydrationEventTypeSchema);
//# sourceMappingURL=datalake.js.map